import { render, staticRenderFns } from "./remind_template.vue?vue&type=template&id=2977bfaa&scoped=true&"
import script from "./remind_template.vue?vue&type=script&lang=js&"
export * from "./remind_template.vue?vue&type=script&lang=js&"
import style0 from "./remind_template.vue?vue&type=style&index=0&id=2977bfaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2977bfaa",
  null
  
)

export default component.exports